import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchLevelList(filter) {
  return request({
    url: '/api/levels',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchLevelLangList(filter) {
  return request({
    url: '/api/level_langs',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchLevel(id, filter) {
  return request({
    url: '/api/levels/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createLevel(data) {
  return request({
    url: '/api/levels',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateLevel(id, data) {
  return request({
    url: '/api/levels/' + id ,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function createLevelLang(data) {
  return request({
    url: '/api/level_langs',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateLevelLang(id, data) {
  return request({
    url: '/api/level_langs/' + id ,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteLevel(id) {
  return request({
    url: '/api/levels/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

export function deleteLevelLang(id) {
  return request({
    url: '/api/level_langs/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}
